import get from'lodash/get';export function shouldDisplayOW(departDate,flightDetails){return!departDate&&!get(flightDetails,'flights[0].departureDate');}
//# sourceMappingURL=shouldDisplayOW.js.map